module.exports = __webpack_public_path__ + "static/img/zhaopian7_Jpg.697972f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhaopian7_Jpg.png
// module id = 9f2X
// module chunks = 1